import { useState } from 'react';
import '../styles/GameSidebar.css';
import { SettingsPanel } from '@/components/Settings';
import Inventory from '@/components/Inventory';
import MarketplacePanel from '@/components/Market';
import EarningsPanel from '@/components/Earnings';
import { IslandList } from "@/components/IslandList"
import ReferralSystem from '@/components/ReferralSystem';
import TasksSystem from '@/components/TasksSystem';
import { UserDashboard } from '@/components/UserDashboard';
import { LocationsPanel } from '@/components/LocationsPanel';

interface GameSidebarProps {
  onClose?: () => void;
  player?: any;
}

export const GameSidebar = ({ onClose, player }: GameSidebarProps) => {
  const [activePanel, setActivePanel] = useState<string | null>(null);

  const handlePanelClose = () => {
    setActivePanel(null); // Reset activePanel to null
  };

  const renderPanel = () => {
    // Pass the onClose handler to each panel component
    switch (activePanel) {
      case 'islands': return <IslandList onClose={handlePanelClose} />;
      case 'inventory': return <Inventory onClose={handlePanelClose} />;
      case 'marketplace': return <MarketplacePanel isOpen={true} onClose={handlePanelClose} />;
      case 'settings': return <SettingsPanel onClose={handlePanelClose} />;
      case 'earnings': return <EarningsPanel onClose={handlePanelClose} />;
      case 'referrals': return <ReferralSystem onClose={handlePanelClose} />;
      case 'tasks': return <TasksSystem onClose={handlePanelClose} />;
      case 'wallet': return <UserDashboard onClose={handlePanelClose} />;
      case 'locations': return <LocationsPanel player={player} onClose={handlePanelClose} />;
      default: return null;
    }
  };

  return (
    <>
      <div className="game-sidebar-container">
        <div className="game-sidebar-header">
          <h3>Menu</h3>
          <button className="close-btn" onClick={() => {
            if (onClose) onClose();
          }} title="Close Menu">❌</button>
        </div>
        <div className="game-sidebar-grid">
          <button onClick={() => setActivePanel('islands')} title="Islands">
            <span className="icon">🪐</span>
            <span className="label">Islands</span>
          </button>
          <button onClick={() => setActivePanel('locations')} title="Locations">
            <span className="icon">📍</span>
            <span className="label">Locations</span>
          </button>
          <button onClick={() => setActivePanel('marketplace')} title="Marketplace">
            <span className="icon">🛒</span>
            <span className="label">Market</span>
          </button>
          <button onClick={() => setActivePanel('inventory')} title="Inventory">
            <span className="icon">🗄️</span>
            <span className="label">Inventory</span>
          </button>
          <button onClick={() => setActivePanel('settings')} title="Settings">
            <span className="icon">⚙️</span>
            <span className="label">Settings</span>
          </button>
          <button onClick={() => setActivePanel('earnings')} title="Earnings">
            <span className="icon">💰</span>
            <span className="label">Earnings</span>
          </button>
          <button onClick={() => setActivePanel('referrals')} title="Referrals">
            <span className="icon">👥</span>
            <span className="label">Referrals</span>
          </button>
          <button onClick={() => setActivePanel('tasks')} title="Tasks">
            <span className="icon">✅</span>
            <span className="label">Tasks</span>
          </button>
          <button onClick={() => setActivePanel('wallet')} title="Wallet">
            <span className="icon">🛅</span>
            <span className="label">Wallet</span>
          </button>
        </div>
      </div>

      {activePanel && (
        <div className="overlay-panel">
          {renderPanel()}
        </div>
      )}
    </>
  );
};
